/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getCustomLongfield01 } from "api/services/quotation";
import { quotationQueryKeys } from "./quotationQueryKeys";

type GetCustomLongfield01Options = {
  shipmentId: string;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetCustomLongfield01 = (data: GetCustomLongfield01Options) =>
  useQuery<any>({
    queryKey: quotationQueryKeys.quotationCustomLongfield01Details(data.shipmentId),
    queryFn: data.queryFn ? data.queryFn : () => getCustomLongfield01(data.shipmentId),
    ...data.options,
  });
